<template>
  <div
    :class="['draw-whale', { 'fixed-center': center, active: loading }]"
  ></div>
</template>

<script>
export default {
  props: {
    center: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.draw-whale {
  width: 36 * 2px;
  height: 32 * 2px;
  background-image: url('../../images/common/whale_frame.png');
  background-size: 36 * 2px;
  margin: 0 auto;
  &.active {
    -webkit-animation: drawWhale 1.4s steps(12) infinite;
    animation: drawWhale 1.4s steps(12) infinite;
    animation-fill-mode: both;
  }

  &.fixed-center {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
  }
}

@keyframes drawWhale {
  0% {
    background-position: 0 0;
  }
  80% {
    background-position: 0 -864 * 2px;
  }
  100% {
    background-position: 0 -864 * 2px;
  }
}
</style>
